import styled from "styled-components";
import { responsive } from "../../../../../../../../../../../../styles/constants.style";

export const ProjectExistingDeliverableWrapper = styled.div`
  margin-top: 16px;

  ${responsive.MOBILE`
      margin-top: 0px;
  `}

  .MuiTableBody-root .MuiTableRow-root .MuiTableCell-root:first-of-type,
  .checkbox-cell {
    padding: 0 16px !important;
  }

  .cell-name {
    width: 290px;
  }

  .existing-header {
    padding: 16px 16px 0px 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .existing-deliverable {
      margin-top: 0;
      ${responsive.MOBILE`
       padding: 8px;
       `}
    }

    ${responsive.MOBILE`
       width: 100%;
       white-space: nowrap;
       overflow: hidden;
       text-overflow: ellipsis;
       padding: 1px;
       margin-left: 8px;
       margin-bottom: 8px;
    `}
  }
`;
